import { CHECK_HOLIDAY, CHECK_HOLIDAY_START_LOADER, CHECK_HOLIDAY_STOP_LOADER, } from "../interface/iCheckHoliday";
const initialState = {
    isHoliday: false,
    checkHolidayLoader: false,
};
const checkHolidayReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_HOLIDAY:
            return Object.assign(Object.assign({}, state), { isHoliday: action.payload.isHoliday });
        case CHECK_HOLIDAY_START_LOADER:
            return Object.assign(Object.assign({}, state), { checkHolidayLoader: true });
        case CHECK_HOLIDAY_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { checkHolidayLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default checkHolidayReducer;
